import { Component, type ErrorInfo, type ReactNode } from 'react';

import { captureClientError } from '../lib/client-observability';

interface AppErrorBoundaryProps {
  readonly children: ReactNode;
}

interface AppErrorBoundaryState {
  readonly failed: boolean;
}

export class AppErrorBoundary extends Component<AppErrorBoundaryProps, AppErrorBoundaryState> {
  public override state: AppErrorBoundaryState = { failed: false };

  public static getDerivedStateFromError(): AppErrorBoundaryState {
    return { failed: true };
  }

  public override componentDidCatch(error: Error, info: ErrorInfo): void {
    captureClientError(error, info.componentStack ?? undefined);
  }

  public override render(): ReactNode {
    if (!this.state.failed) return this.props.children;

    const english = document.documentElement.lang === 'en';
    return (
      <main className="fatal-error" role="alert">
        <div>
          <p>FinanceGo</p>
          <h1>{english ? 'The app needs to restart' : 'La aplicación necesita reiniciarse'}</h1>
          <p>
            {english
              ? 'Your financial data was not changed.'
              : 'Tus datos financieros no fueron modificados.'}
          </p>
          <button type="button" onClick={() => window.location.reload()}>
            {english ? 'Reload' : 'Volver a cargar'}
          </button>
        </div>
      </main>
    );
  }
}
